export default "__VITE_ASSET__Cy0_iuvQ__"